import React from "react";

import {withStyles} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

import styles from "./styles";


const BaseDialogLoader = (props) => {
  const {classes, msg} = props;

  return (
    <div className={classes.loadWrapper}>
      <CircularProgress color={'primary'}/>
      {!!msg &&
        <p className={classes.loadMessage}>
          {msg}
        </p>
      }
    </div>
  )
};

export default  withStyles(styles)(BaseDialogLoader);